"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungFactory = void 0;
const Karton_1 = require("./Karton");
const Palette_1 = require("./Palette");
const Trommel_1 = require("./Trommel");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * The `VerpackungFactory` provides methods to create `Verpackung` articles
 */
class VerpackungFactory {
    /**
     * Creates a `Verpackung` on base of an existing ArtNr
     *
     * @param args The arguments to create the article with
     * @returns The created `Verpackung`
     */
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        switch (args.Typ) {
            case echain_shared_articles_1.VerpackungType.palette:
                return Palette_1.Palette.fromExistingArtNr(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.trommel:
                return Trommel_1.Trommel.fromExistingArtNr(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.karton:
                return Karton_1.Karton.fromExistingArtNr(args, cloneStrategy);
            default:
                throw new Error('VerpackungFactory.fromExistingArtNr: invalid typ ' + args.Typ);
        }
    }
    /**
     * Creates a `Verpackung` without an existing ArtNr
     *
     * @param args The arguments to create the article with
     * @returns The created `Verpackung`
     */
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        switch (args.Typ) {
            case echain_shared_articles_1.VerpackungType.palette:
                return Palette_1.Palette.fromInventedArtNr(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.trommel:
                return Trommel_1.Trommel.fromInventedArtNr(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.karton:
                return Karton_1.Karton.fromInventedArtNr(args, cloneStrategy);
            default:
                throw new Error('VerpackungFactory.fromInventedArtNr: invalid typ ' + args.Typ);
        }
    }
    /**
     * Creates a `Verpackung` using a given `VerpackungJson`
     *
     * @param args The arguments to create the article with
     * @returns The created `Verpackung`
     */
    static fromJson(args, cloneStrategy = 'deep') {
        switch (args.Typ) {
            case echain_shared_articles_1.VerpackungType.palette:
                return Palette_1.Palette.fromJson(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.trommel:
                return Trommel_1.Trommel.fromJson(args, cloneStrategy);
            case echain_shared_articles_1.VerpackungType.karton:
                return Karton_1.Karton.fromJson(args, cloneStrategy);
            default:
                throw new Error('VerpackungFactory.fromJson: invalid typ ' + args.Typ);
        }
    }
    static fromModel(args) {
        switch (args.Typ) {
            case echain_shared_articles_1.VerpackungType.palette:
                return Palette_1.Palette.fromModel(args);
            case echain_shared_articles_1.VerpackungType.trommel:
                return Trommel_1.Trommel.fromModel(args);
            case echain_shared_articles_1.VerpackungType.karton:
                return Karton_1.Karton.fromModel(args);
            default:
                throw new Error('VerpackungFactory.fromModel: invalid typ ' + args.Typ);
        }
    }
}
exports.VerpackungFactory = VerpackungFactory;
//# sourceMappingURL=VerpackungFactory.js.map